<template>
  <div id="CustomerService">
    <div class="cs-btn" @click="openService" title="微信在线客服">
      <span class="glyphicon glyphicon-headphones"></span>
      <span class="cs-text">客服</span>
    </div>
    <div class="cs-tooltip" v-show="showTip" @mouseleave="showTip=false">
      <div class="cs-tooltip-header">微信在线客服</div>
      <div class="cs-tooltip-body">
        <p>施工日志@奇智科技</p>
        <a :href="serviceUrl" target="_blank" class="cs-link">立即咨询</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CustomerService",
  data() {
    return {
      showTip: false,
      serviceUrl: 'https://work.weixin.qq.com/kfid/kfc7f9fe8e2b464d24f'
    };
  },
  methods: {
    openService() {
      this.showTip = !this.showTip;
    }
  }
};
</script>
<style scoped>
#CustomerService {
  position: fixed;
  right: 10px;
  bottom: 140px;
  z-index: 99999998;
}
.cs-btn {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1976D2 0%, #42A5F5 100%);
  color: #fff;
  text-align: center;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(30,115,190,0.35);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: csPulse 2s infinite;
}
.cs-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 24px rgba(30,115,190,0.5);
}
.cs-btn span.glyphicon {
  font-size: 26px;
  display: block;
}
.cs-text {
  font-size: 12px;
  letter-spacing: 1px;
  margin-top: 2px;
}
@keyframes csPulse {
  0%, 100% {
    box-shadow: 0 4px 16px rgba(30,115,190,0.35);
  }
  50% {
    box-shadow: 0 4px 24px rgba(30,115,190,0.55);
  }
}
.cs-tooltip {
  position: absolute;
  bottom: 5px;
  right: 70px;
  width: 220px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.15);
  overflow: hidden;
  animation: fadeIn 0.3s ease;
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateX(10px); }
  to { opacity: 1; transform: translateX(0); }
}
.cs-tooltip-header {
  background: linear-gradient(135deg, #1976D2 0%, #42A5F5 100%);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 15px;
  text-align: center;
}
.cs-tooltip-body {
  padding: 15px;
  text-align: center;
}
.cs-tooltip-body p {
  font-size: 13px;
  color: #666;
  margin: 0 0 8px;
  line-height: 1.5;
}
.cs-link {
  display: inline-block;
  padding: 8px 24px;
  background: linear-gradient(135deg, #1976D2 0%, #42A5F5 100%);
  color: #fff;
  border-radius: 20px;
  font-size: 13px;
  text-decoration: none;
  margin-top: 5px;
  transition: all 0.3s ease;
}
.cs-link:hover {
  background: linear-gradient(135deg, #1259A1 0%, #1976D2 100%);
  color: #fff;
  text-decoration: none;
  box-shadow: 0 4px 12px rgba(30,115,190,0.3);
}
@media screen and (max-width: 767px) {
  #CustomerService {
    right: 5px;
    bottom: 120px;
  }
  .cs-btn {
    width: 48px;
    height: 48px;
  }
  .cs-btn span.glyphicon {
    font-size: 18px;
  }
  .cs-tooltip {
    right: 58px;
    width: 200px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/CustomerService.vue